/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getCurrentPageIndex } from "selectors/pageNumber";
import { getThumbnailColumnCount } from "selectors/thumbnailSelectors";
import { getThumbnailsTopPadding } from "thumbnails/ThumbnailService";

export const getCurrentThumbnailYPositionFromTop = (stores, thumbnailHeight) => {
  // There can be multiple thumbnails in single row of thumbnail panel, we are finding the total height from first row to the row having the current thumbnail to get the position from top
  const rowCountTillCurrentIndex = Math.floor(getCurrentPageIndex(stores) / getThumbnailColumnCount(stores));
  return rowCountTillCurrentIndex * thumbnailHeight + getThumbnailsTopPadding(stores);
};
